export default __webpack_public_path__ + "static/media/close.a3544b67.svg";